import { IStatisticConfig } from "components/base/Statistic/services/typings";
import { Dictionary, get } from "lodash";
import RestAPIClient from "./RestAPIClient";

class MetricService extends RestAPIClient {
  constructor() {
    super("metrics");
    this.caches = {};
  }

  private caches: Dictionary<IStatisticConfig[]>;

  getMetric = async (
    kind:
      | "campaign-partner"
      | "campaign-universal"
      | "link-performance"
      | "program-manager"
      | "invoice"
      | "advertiser_invoice"
      | "dashboard"
      | "program-manager-seller"
      | "advertiser-report-overview"
      | "campaign-universal-cpa"
      | "campaign-partner-cpa"
      | "campaign-universal-cps"
      | "campaign-partner-cps"
      | "invoice_cpa"
      | "advertiser_invoice_cpa"
      | "program-manager-cps"
      | "program-manager-cpa"
  ): Promise<IStatisticConfig[]> => {
    const cached = get(this.caches, kind);
    if (!!cached) return cached;
    const res = await this.get(`/${kind}`);
    this.caches[kind] = res.data;
    return res.data;
  };

  clearCache = () => {
    this.caches = {};
  };
}

export default new MetricService();
